import { Link } from "react-router-dom"

const Breadcrumbs = (props) => {
    return (
        <div className="mb-4">
            <Link to={`${props.currentUser && props.currentUser.entityId ? '/museum-dashboard/' + props.currentUser.entityId : '/museums'}`}>Home</Link> <span className="px-2">/</span>
            {props.items.map((item, index) => (item.length > 1
                ? <span key={index}>
                    <Link to={item[1]}>{item[0]}</Link> <span className="px-2">/</span>
                  </span>
                : <span key={index}>{item[0]}</span>
            ))}
        </div>
    )
}

export default Breadcrumbs